import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Col, Container, Row, Input, Label, FormGroup } from "reactstrap";
import { Modal } from "react-bootstrap";
import { numberWithCommas } from "../../utils/customFunction";
import ReactTooltip from "react-tooltip";
import { getAllCompanies } from "../../stores/services/company.service";
import { useHistory } from "react-router-dom";
import AddCompany from "./addCompany";
import EditCompany from "./editCompany";
import ViewCompany from "./viewCompany";

function CompanyListing() {
  const history = useHistory();
  const [allData, setAllData] = useState<any>([]);
  console.log("asdasd", allData);
  const [loading, setLoading] = useState<boolean>(false);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<any>({});
  const [viewModalFlag, setViewModalFlag] = useState<boolean>(false);
  const [addModalFlag, setAddModalFlag] = useState<boolean>(false);
  const [editModalFlag, setEditModalFlag] = useState<boolean>(false);

  // Search and pagination states
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [companyCode, setCompanyCode] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);

  const email = sessionStorage.getItem("email") || "";
  const amcCode = sessionStorage.getItem("amc_code") || "";

  const getListing = async () => {
    try {
      setLoading(true);
      const response = await getAllCompanies({
        email: email,
        amc_code: amcCode,
        company_code: companyCode,
        name_of_company: companyName,
        search: searchTerm,
        page: page,
        limit: limit,
        sort_by: "creation_time",
        sort_order: "desc",
      });
      if (response.data.status == 200) {
        setAllData(response.data.data);
        setTotalRecords(response.data.pagination.total);
        setTotalPages(response.data.pagination.totalPages);
      } else {
        toast.error("No record found!");
        setAllData([]);
        setTotalRecords(0);
        setTotalPages(0);
      }
    } catch (error: any) {
      setAllData([]);
      setTotalRecords(0);
      setTotalPages(0);
      toast.error(error?.response?.data?.message || "Error fetching companies");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getListing();
  }, [refreshData, page, limit]);

  const handleSearch = () => {
    setPage(1); // Reset to first page on new search
    setRefreshData(!refreshData);
  };

  const handleReset = () => {
    setSearchTerm("");
    setCompanyCode("");
    setCompanyName("");
    setPage(1);
    setLimit(10);
    setRefreshData(!refreshData);
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
      // Increase limit by 10 for progressive loading
      setLimit(limit + 10);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
      // Decrease limit by 10, but keep minimum at 10
      setLimit(Math.max(10, limit - 10));
    }
  };

  const renderData = () => {
    return allData?.map((items: any, index: any) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{items?.company_type || "N/A"}</td>
          <td>{items?.company_code}</td>
          <td>{items?.name_of_company}</td>
          <td>{items?.ntn}</td>
          <td>{items?.company_focal_name || "N/A"}</td>
          <td>{items?.company_focal_email || "N/A"}</td>
          <td>{items?.mobile || "N/A"}</td>
          <td>{moment(items?.creation_time)?.format("DD-MM-YYYY")}</td>
          <td className="text-center">
            <div className="d-flex">
              <ReactTooltip
                textColor="white"
                backgroundColor="black"
                effect="float"
              />
              <button
                data-tip="View"
                onClick={() => {
                  setSelectedItems(items);
                  setViewModalFlag(true);
                }}
                type="button"
                className="btn-icon btn-link like btn btn-info btn-sm"
              >
                <i className="fa fa-eye"></i>
              </button>
              <ReactTooltip
                textColor="white"
                backgroundColor="black"
                effect="float"
              />
              <button
                data-tip="Edit"
                onClick={() => {
                  setEditModalFlag(true);
                  setSelectedItems(items);
                }}
                type="button"
                className="btn-icon btn-link like btn btn-warning btn-sm"
              >
                <i className="fa fa-edit"></i>
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="content">
      {/* ------------------------  Add Modal ------------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={addModalFlag ? true : false}
        size="xl"
        backdrop={true}
        onHide={() => {
          setAddModalFlag(false);
          setSelectedItems("");
        }}
        centered={true}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setAddModalFlag(false);
              setSelectedItems("");
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">Add Company Details</h6>
        </div>
        <div className="modal-body">
          <AddCompany
            setAddModalFlag={setAddModalFlag}
            setRefreshData={setRefreshData}
            refreshData={refreshData}
          />
        </div>
      </Modal>

      {/* ------------------------  Edit Modal ------------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={editModalFlag ? true : false}
        size="xl"
        backdrop={true}
        onHide={() => {
          setEditModalFlag(false);
          setSelectedItems("");
        }}
        centered={true}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setEditModalFlag(false);
              setSelectedItems("");
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">Edit Company Details</h6>
        </div>
        <div className="modal-body">
          <EditCompany
            setEditModalFlag={setEditModalFlag}
            selectedItems={selectedItems}
            setRefreshData={setRefreshData}
            refreshData={refreshData}
          />
        </div>
      </Modal>

      {/* ------------------------  View Modal ------------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={viewModalFlag ? true : false}
        size="xl"
        backdrop={true}
        onHide={() => {
          setViewModalFlag(false);
          setSelectedItems("");
        }}
        centered={true}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setViewModalFlag(false);
              setSelectedItems("");
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">View Company Details</h6>
        </div>
        <div className="modal-body">
          <ViewCompany
            setViewModalFlag={setViewModalFlag}
            selectedItems={selectedItems}
          />
        </div>
      </Modal>

      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />
            <div className="card">
              <div className="card-header">
                <div className="card-title">
                  <h4 className="d-flex justify-content-between align-items-center">
                    Company Listing
                    <button
                      className="btn btn-primary btn-sm float-right"
                      onClick={() => {
                        setAddModalFlag(true);
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i> Add Company
                    </button>
                  </h4>
                </div>
              </div>
              <div className="card-body">
                {/* Search Filters */}
                <Row className="mb-4">
                  <Col md="3">
                    <FormGroup>
                      <Label>Search</Label>
                      <Input
                        type="text"
                        placeholder="Search by name, code, email..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleSearch();
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="d-flex align-items-end">
                    <FormGroup className="d-flex gap-2 w-100">
                      <button
                        className="btn btn-primary"
                        onClick={handleSearch}
                      >
                        <i className="fa fa-search mr-2"></i> Search
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={handleReset}
                      >
                        <i className="fa fa-refresh mr-2"></i> Reset
                      </button>
                    </FormGroup>
                  </Col>
                </Row>

                {loading ? (
                  <div className="d-flex justify-content-center my-5">
                    <i
                      className="fa fa-spinner fa-spin fa-3x"
                      aria-hidden="true"
                    ></i>
                  </div>
                ) : !loading && allData?.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Company Type</th>
                            <th>Company Code</th>
                            <th>Company Name</th>
                            <th>NTN</th>
                            <th>Focal Person</th>
                            <th>Focal Email</th>
                            <th>Mobile</th>
                            <th>Created At</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>{renderData()}</tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    <Row className="mt-4">
                      <Col md="12">
                        <div className="d-flex justify-content-between align-items-center">
                          <button
                            className="btn btn-secondary"
                            onClick={handlePreviousPage}
                            disabled={page === 1}
                          >
                            <i className="fa fa-arrow-left mr-2"></i>
                            Previous
                          </button>

                          <div className="d-flex gap-2">
                            {Array.from(
                              { length: Math.min(5, totalPages) },
                              (_, i) => {
                                let pageNum;
                                if (totalPages <= 5) {
                                  pageNum = i + 1;
                                } else if (page <= 3) {
                                  pageNum = i + 1;
                                } else if (page >= totalPages - 2) {
                                  pageNum = totalPages - 4 + i;
                                } else {
                                  pageNum = page - 2 + i;
                                }
                                return (
                                  <button
                                    key={i}
                                    className={`btn ${
                                      pageNum === page
                                        ? "btn-primary"
                                        : "btn-outline-primary"
                                    }`}
                                    onClick={() => setPage(pageNum)}
                                  >
                                    {pageNum}
                                  </button>
                                );
                              }
                            )}
                          </div>

                          <button
                            className="btn btn-primary"
                            onClick={handleNextPage}
                            disabled={page >= totalPages}
                          >
                            Next (Load {limit + 10})
                            <i className="fa fa-arrow-right ml-2"></i>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <div className="d-flex justify-content-center">
                    <b className="my-5">No record found!</b>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default CompanyListing;
